import axios from 'axios';

import { getTokenTMOV, startRefreshToken } from '../security/authService';

const apiDatalake = axios.create({
  baseURL: process.env.REACT_APP_API_DATALAKE_URL,
});

apiDatalake.interceptors.request.use(async config => {
  const token = getTokenTMOV();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

apiDatalake.interceptors.response.use(
  response => response,
  reject => {
    const originalRequest = reject.config;
    if (
      reject.response?.status === 401 &&
      !originalRequest._retry &&
      window.location.hash !== '#/'
    ) {
      return startRefreshToken(originalRequest);
    }
    return Promise.reject(reject);
  }
);

export default apiDatalake;
